module.exports = __webpack_public_path__ + "dash_20_app_assets/img/ta.3b4e0113.png";